import { Loading } from '@components/loadling';
import { initSdk, onApiError } from '@proccess/api';
import sdkDoctor from '@proccess/sdk/doctor';
import { actions } from '@store/reducer';
import { AxiosResponse } from 'axios';
import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { RQHeathIndicator } from './@define/type';
import { patientActions } from './slice';

function* requestPatients({ payload: { page = 0, limit } }: any) {
  try {
    const { data }: AxiosResponse = yield call(() =>
      initSdk.get('/admin/patients', {
        params: {
          page,
        },
      })
    );

    if (data?.patients) {
      yield put(
        patientActions.savePatients({
          data: {
            ...data,
            limit,
          },
        })
      );
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherrequestPatients() {
  yield takeEvery(patientActions.requestPatients, requestPatients);
}

function* requestHeathIndicatorForDoctor({ payload: { patient_id } }: RQHeathIndicator) {
  try {
    const response: AxiosResponse = yield call(() =>
      sdkDoctor.getMedicalHeathDoctor({ patient_id })
    );

    if (response.data) {
      yield put(actions.saveHeathIndicatorForDoctor({ data: response.data }));
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestHeathIndicatorDoctor() {
  yield takeLatest(actions.requestHeathIndicatorForDoctor, requestHeathIndicatorForDoctor);
}

const patientSagas = function* root() {
  yield all([fork(watcherrequestPatients), fork(watcherRequestHeathIndicatorDoctor)]);
};

export { patientSagas };
